export default __webpack_public_path__ + "static/media/section0-bg1.44b0f789.png";